/* eslint-disable prettier/prettier */
/* eslint-disable*/
import { useState, useEffect, useRef, useContext, useCallback, Suspense } from "react";
import { ListItem, ListItemText, ListItemAvatar, List, Paper, Box } from "@material-ui/core";
import { NOTIFICATION_TYPE } from "../../../constants/notification/notificationType";
import { io } from "socket.io-client";
import Skeleton from "@material-ui/lab/Skeleton";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { NotificationIconType, TabName } from "../../../@types/notifications.types";
import { UIContext } from "../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../constants/caption/dashboardHeader";
import { NOTIFICATION_ICON_TYPE } from "../../../constants/notification/notificationIconType";
import { api } from "../../../utils/api";
import { port, url } from "../../../config/config";
import { NOTIFICATION_TABS } from "../../../constants/notification/notificationTabs";
import { LazyNotification } from "..";

import "./allNotifications.css";
import { trackPromise } from "react-promise-tracker";

const AllNotifications = () => {
	const [pageNumber, setPageNumber] = useState(0);
	const [tabName, setTabName] = useState<TabName>("all");
	const [hasFetchedAllNotifications, setHasFetchedAllNotifications] = useState(false);
	const [newNotifications, setNewNotifications] = useState<any[]>([]);
	const [oldNotifications, setOldNotifications] = useState<any[]>([]);
	const [filteredNewNotifications, setFilteredNewNotifications] = useState([]);
	const [filteredOldNotifications, setFilteredOldNotifications] = useState([]);
	const [limit, setLimit] = useState<number>();
	const [skeletonLoad, setSkeletonLoad] = useState(false);
	const { setDashboardHeader } = useContext(UIContext);

	let loading = useRef(false);

	const scrollToEnd = () => {
		if (loading.current === false) {
			setPageNumber(pageNumber + 1);
		}
	};

	window.onscroll = () => {
		var { scrollHeight, scrollTop, clientHeight } = document.documentElement;

		if (scrollTop + clientHeight > scrollHeight - 5) {
			// console.log("Reached just Bottom");
			scrollToEnd();
		}
	};

	const getNotifications = useCallback(async () => {
		// console.log("pageNumber", pageNumber);
		const params = {
			page: pageNumber + 1,
			limit
		};
		const response = await trackPromise(api.notification.getNotificationsByUserId(params));
		if (response === false) {
			setHasFetchedAllNotifications(true);
			setSkeletonLoad(false);
			loading.current = false;
			return;
		}
		if (response) {
			// console.log("response.oldNotifications", response.oldNotifications);
			setNewNotifications(Object.assign([], [...response.newNotifications]));
			setOldNotifications((prevOldNotification) => {
				return Object.assign([], [...prevOldNotification, ...response.oldNotifications]);
			});
			loading.current = false;
			setSkeletonLoad(false);
		}
	}, [limit, pageNumber]);

	const listenNotification = useCallback(() => {
		let socket = io(`${url}:${port}`);
		socket.on(NOTIFICATION_TYPE.super_admin_sign_up, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.registration, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.creation, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.edit, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.approval, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.member_chat_support, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.employer_chat_support, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.blogs, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.announcements, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.statement_of_understanding, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.registration_help, (message) => {
			setNewNotifications((prevNewNotifications: any[]) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.plan_creation, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.open_enrollment, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.enrollment_submission, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.terminate, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.reinstate, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});

		socket.on(NOTIFICATION_TYPE.rehire, (message: any) => {
			setNewNotifications((prevNewNotifications: any) => {
				return [message, ...prevNewNotifications];
			});
		});
	}, []);

	useEffect(() => {
		listenNotification();
	}, [listenNotification]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.notifications);
		//setLimit(ALL_NOTIFICATIONS_LIMIT.xl);
		setLimit(12);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (pageNumber !== 0 && !hasFetchedAllNotifications) {
			loading.current = true;
			setSkeletonLoad(true);
		}
		if (limit && !hasFetchedAllNotifications) {
			getNotifications();
		}
	}, [getNotifications, hasFetchedAllNotifications, limit, pageNumber]);

	const filterNotification = (notifications: any[], _type: string) => {
		const filteredNotifications: any[] = [];
		notifications.forEach((notification: any) => {
			if (_type === "all") {
				filteredNotifications.push(notification);
			} else if (notification.type === _type) {
				filteredNotifications.push(notification);
			}
		});
		return filteredNotifications;
	};

	const setAllNotificationByOld = useCallback(async () => {
		const response = await api.notification.setAllNotificationsAsOldByUserId();
		if (response) {
			setOldNotifications(Object.assign([], [...response.oldNotifications]));
			setNewNotifications(Object.assign([], response.newNotifications));
		}
	}, []);

	const handleTabChange = (event: any, newValue: TabName) => {
		setTabName(newValue);
		const _filteredNewNotifications = filterNotification(newNotifications, newValue);
		const _filteredOldNotifications = filterNotification(oldNotifications, newValue);
		setFilteredNewNotifications(Object.assign([], _filteredNewNotifications));
		setFilteredOldNotifications(Object.assign([], _filteredOldNotifications));
	};

	useEffect(() => {
		const _filteredNewNotifications = filterNotification(newNotifications, tabName);
		const _filteredOldNotifications = filterNotification(oldNotifications, tabName);
		setFilteredNewNotifications(Object.assign([], _filteredNewNotifications));
		setFilteredOldNotifications(Object.assign([], _filteredOldNotifications));
	}, [tabName, newNotifications, oldNotifications]);

	useEffect(() => {
		setAllNotificationByOld();
	}, []);

	return (
		<div className="all-notificaions" id="all-notificaions">
			<Paper className="notification-paper" id="notification-paper">
				<Box sx={{ flexGrow: 1, bgcolor: "background.paper" }}>
					<Tabs
						value={tabName}
						onChange={handleTabChange}
						variant={NOTIFICATION_TABS.length < 6 ? "fullWidth" : "scrollable"}
						//ariant="scrollable"
						scrollButtons="auto"
						centered
						TabIndicatorProps={{
							style: {
								backgroundColor: "#AED580"
							}
						}}
						textColor="primary"
					>
						{NOTIFICATION_TABS.map((tab, index) => (
							<Tab
								key={index}
								style={{
									color: tabName === tab.value ? "#AED580" : "inherit",
									fontSize: "14px",
									fontFamily: "Quicksand",
									minWidth: "25%"
								}}
								label={tab.label}
								icon={
									<i className={NOTIFICATION_ICON_TYPE[tab.value as keyof NotificationIconType]}></i>
								}
								value={tab.value}
							/>
						))}
						;
					</Tabs>
				</Box>
				<List>
					<>
						{filteredNewNotifications.length > 0 ? <b>New</b> : ""}
						{filteredNewNotifications
							? filteredNewNotifications.map((filteredNewNotification, index) => {
									return (
										<Suspense fallback={<div />} key={index}>
											<LazyNotification notification={filteredNewNotification} key={index} />
										</Suspense>
									);
							  })
							: ""}
						{filteredNewNotifications.length > 0 && filteredOldNotifications.length ? <b>Earlier</b> : ""}
						{filteredOldNotifications
							? filteredOldNotifications.map((filteredOldNotification, index) => {
									return (
										<Suspense fallback={<div />} key={index}>
											<LazyNotification notification={filteredOldNotification} key={index} />
										</Suspense>
									);
							  })
							: ""}
						{loading.current && skeletonLoad ? (
							<div className="skeleton-container">
								<div className="loading-skeleton">
									<ListItem>
										<ListItemAvatar>
											<Skeleton animation="wave" variant="circle" width={40} height={40} />
										</ListItemAvatar>
										<ListItemText
											className="list-item-text"
											primary={
												<Skeleton
													animation="wave"
													height={10}
													width="70%"
													style={{ marginBottom: 6 }}
												/>
											}
											secondary={<Skeleton animation="wave" height={10} width="30%" />}
										/>
									</ListItem>
								</div>
								<div className="loading-skeleton">
									<ListItem>
										<ListItemAvatar>
											<Skeleton animation="wave" variant="circle" width={40} height={40} />
										</ListItemAvatar>
										<ListItemText
											className="list-item-text"
											primary={
												<Skeleton
													animation="wave"
													height={10}
													width="70%"
													style={{ marginBottom: 6 }}
												/>
											}
											secondary={<Skeleton animation="wave" height={10} width="30%" />}
										/>
									</ListItem>
								</div>
							</div>
						) : (
							""
						)}
					</>
				</List>
			</Paper>
		</div>
	);
};

export default AllNotifications;
